module.exports = __webpack_public_path__ + "img/coup31.42a3b262.png";